<template>
    <section id="Clinician__Map" class="dashboard-card">
        <!-- CONTENT -->
        <template v-if="!zipNotEntered">
            <div v-show="!zipNotEntered" class="p-0 w-100 h-100" id="Tasks__Map">
                <div class="d-flex w-100 justify-content-center mt-4">
                    <i class="fas fa-spinner fa-pulse fa-fw"></i>
                    <b class="mx-2">Waiting for your location</b>
                    <i class="fas fa-spinner fa-pulse fa-fw"></i>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="d-flex flex-column align-items-center px-3 mt-4 text-center">
                <p class="font-size-md mb-2">
                    Provide your location to view how far your visits are from your location.
                </p>
                <button class="btn btn-xs btn-primary" @click="enterLocation()">ENTER LOCATION</button>
            </div>
        </template>
    </section>
</template>

<script lang="ts" src="./TasksMap.ts"></script>
<style src="./TasksMap.scss"></style>
